import {Container, Typography} from "@mui/material";
import {Helmet} from "react-helmet";

export default function ConnectedDevices() {
    return (
        <>
            <Helmet>
                <title>درایو میلفا - دستگاه های متصل</title>
                </Helmet>
            <Container sx={{ mt: 3 }}>
                <Typography fontSize={{ xs: "1.1rem" }} fontWeight={600}>دستگاه های متصل</Typography>
            </Container>
        </>
    )
}
